import React from "react";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_TEL, EMAIL, ADDRESS, FACEBOOK_URL } from "../lib/assets";
import { useLang } from "../context/LangContext";

const Footer = () => {
  const { t } = useLang();

  const sections = [
    { id: "about", label: t.nav.about },
    { id: "pricing", label: t.nav.pricing },
    { id: "docs", label: t.nav.docs },
    { id: "gallery", label: t.nav.gallery },
    { id: "faq", label: t.nav.faq },
    { id: "contact", label: t.nav.contact },
  ];

  const handleNav = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="bg-brand-navy-deep text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="BIU BIU DRIVING" className="h-12 w-12 object-contain bg-white rounded-xl p-1" />
              <div>
                <p className="font-display font-extrabold text-lg">BIU BIU DRIVING</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-brand-orange font-bold">Școală de șoferi</p>
                <p className="text-[10px] tracking-wider text-white/60 font-medium italic mt-0.5">Building Better Drivers</p>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>

            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 hover:bg-[#1877F2] border border-white/10 hover:border-[#1877F2] text-white text-sm font-semibold transition-all"
              aria-label="Pagina noastră de Facebook"
            >
              <Facebook className="w-4 h-4" />
              Facebook
            </a>
          </div>

          <div>
            <h4 className="font-display text-base font-bold mb-4 uppercase tracking-wider">{t.footer.quickLinks}</h4>
            <ul className="space-y-2.5">
              {sections.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => handleNav(s.id)}
                    data-testid={`footer-link-${s.id}`}
                    className="text-white/70 hover:text-brand-orange transition-colors text-sm"
                  >
                    {s.id === "faq" ? t.nav.faqFull : s.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base font-bold mb-4 uppercase tracking-wider">{t.footer.contactTitle}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-brand-orange flex-shrink-0" />
                <a href={`tel:${PHONE_TEL}`} className="text-white/80 hover:text-brand-orange transition-colors">
                  {PHONE}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-brand-orange flex-shrink-0" />
                <a href={`mailto:${EMAIL}`} className="text-white/80 hover:text-brand-orange transition-colors break-all">
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-orange flex-shrink-0" />
                <span className="text-white/80">{ADDRESS}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} BIU BIU DRIVING. {t.footer.rights}
          </p>
          <p className="text-xs text-white/50">bbdriving.ro</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
